import { IdentifierDTO } from '@zazume/zzm-base';

import { doGet, doPost, doPut } from '../../helpers';

export type AgentAvailabilityExceptionType = 'vacation' | 'dayOff' | 'customHours';

export interface TimePeriodDTO {
  from: string;
  to: string;
}

export interface AgentWeekSchedulingDTO {
  monday: TimePeriodDTO[];
  tuesday: TimePeriodDTO[];
  wednesday: TimePeriodDTO[];
  thursday: TimePeriodDTO[];
  friday: TimePeriodDTO[];
  saturday: TimePeriodDTO[];
  sunday: TimePeriodDTO[];
}

export interface AgentAvailabilityExceptionDTO {
  type: AgentAvailabilityExceptionType;
  from: string;
  to: string;
  customHours?: TimePeriodDTO[];
}

export interface AgentAvailability {
  _id: string;
  agentId: string;
  weekScheduling: AgentWeekSchedulingDTO;
  exceptions: AgentAvailabilityExceptionDTO[];
  createdAt: string;
  updatedAt: string;
}

export interface UpdateAgentAvailabilityBody {
  weekScheduling: AgentWeekSchedulingDTO;
  exceptions: AgentAvailabilityExceptionDTO[];
}

export const agentAvailability = {
  get: (agentId: IdentifierDTO) => () => doGet<AgentAvailability | null>(`/dashboard/agent-availability/${agentId}`),
  update: (agentId: IdentifierDTO) => (body: UpdateAgentAvailabilityBody) =>
    doPut<AgentAvailability>(`/dashboard/agent-availability/${agentId}`, body),
  confirmMine: () => doPost<AgentAvailability>('/dashboard/agent-availability/confirm')
};
